
// Admin
  export const ADMIN_PORTFOLIOS_ACTIONS = {
    // list
    PORTFOLIOS_LIST_REQUEST: "ADMIN_PORTFOLIOS_LIST_REQUEST",
    PORTFOLIOS_LIST_RESPONSE: "ADMIN_PORTFOLIOS_LIST_RESPONSE",
    PORTFOLIOS_LIST_ERROR: "ADMIN_PORTFOLIOS_LIST_ERROR",

    // create
    PORTFOLIOS_REQUEST: "PORTFOLIOS_REQUEST",
    PORTFOLIOS_RESPONSE: "PORTFOLIOS_RESPONSE",
    PORTFOLIOS_ERROR: "PORTFOLIOS_ERROR",

    // update
    PORTFOLIOS_EDIT_REQUEST: "PORTFOLIOS_EDIT_REQUEST",
    PORTFOLIOS_EDIT_RESPONSE: "PORTFOLIOS_EDIT_RESPONSE",
    PORTFOLIOS_EDIT_ERROR: "PORTFOLIOS_EDIT_ERROR",

    // delete
    PORTFOLIOS_DELETE_REQUEST: "PORTFOLIOS_DELETE_REQUEST",
    PORTFOLIOS_DELETE_RESPONSE: "PORTFOLIOS_DELETE_RESPONSE",
    PORTFOLIOS_DELETE_ERROR: "PORTFOLIOS_DELETE_ERROR",
  };
  